import { EmptyStateArt, emptyStateArt } from '@/assets/empty-states'
import React from 'react'
import { EmptyBody, EmptyIcon, EmptyText } from './EmptyState.styles'

interface EmptyStateProps {
	/**
	 * Which drawing from the shared zero-state art set to show, rendered in gold.
	 * Omit for the teaser variant. The same set backs the page-level zero-states,
	 * so a section's tile and its page show the same drawing.
	 */
	art?: EmptyStateArt
	/** Friendly one-liner. The navigate CTA is the tile footer, so none is rendered here. */
	text: string
}

/**
 * The shared designed zero-state used by every bento tile: centered line art
 * over a friendly line, sitting above the tile's navigate-to-section footer.
 * Extracted from `ItineraryTile` so all tiles read identically (review
 * decision). Omitting the art yields the public-mode teaser body (copy only,
 * no content leak).
 */
const EmptyState: React.FC<EmptyStateProps> = ({ art, text }) => {
	const Art = art ? emptyStateArt[art] : null

	return (
		<EmptyBody>
			{Art && (
				<EmptyIcon aria-hidden="true">
					<Art />
				</EmptyIcon>
			)}
			<EmptyText>{text}</EmptyText>
		</EmptyBody>
	)
}

export default EmptyState
